import React from 'react'
import styles from './SlateEditor.scss'

const SlateEditor = props =>
  <div className={styles.SlateEditor} />

SlateEditor.propTypes = {}

export default SlateEditor



// WEBPACK FOOTER //
// ./src/components/SlateEditor/SlateEditor.js